
import React, { forwardRef, ReactNode } from 'react';
import { SSection } from '../../styles/pages/Home';
import { staggerContainer } from '../../variants';

type SectionHType = {
  backgroundColor: string,
  children: ReactNode,
  id?: string
}

const Section = forwardRef<HTMLTableSectionElement, SectionHType>(({ backgroundColor, children, id }, ref) => {

  return (
    <SSection
      backgroundcolor={backgroundColor}
      variants={staggerContainer}
      ref={ref}
      initial={'initial'}
      whileInView={'animate'}
      viewport={{ once: true, amount: 0.1 }}
      id={id}
    >
      {children}
    </SSection>
  );
})

export default Section;